var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRating = function SvgIconRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 18.018-5.264 2.906a.601.601 0 0 1-.882-.635l1.093-6.005-4.362-4.212a.603.603 0 0 1 .337-1.03l5.955-.8 2.579-5.496a.6.6 0 0 1 1.088 0l2.579 5.497 5.955.798c.498.067.7.681.337 1.03l-4.363 4.213 1.094 6.005c.09.499-.438.88-.882.635z"
  })));
};
export default SvgIconRating;